const footer = {
  "footer.cookie": "Cookie Settings",
  "footer.about": "關於安視優®睛漾水凝®",
  "footer.contact": "聯繫我們",
  "footer.policy": "隱私權政策",
  "footer.notice": "法律聲明",
  "footer.legal": "<p>警語：（一）配戴一般隱形眼鏡須經眼科醫師驗光配鏡取得處方箋，或經驗光人員驗光配鏡取得配鏡單，並定期接受眼科醫師追蹤檢查。（二）本器材不得逾中文仿單建議之最長配戴時數、不得重覆配戴，於就寢前務必取下，以免感染或潰瘍。（三）如有不適，應立即就醫。安視優®睛漾水凝®每日拋（衛署醫器輸字第021286號/衛部醫器輸字第035047號）。北市衛器廣字第113100213號。2024270 202411。</p><p>© Johnson & Johnson Pte. Ltd 2024。</p> <p>本網站由 Johnson & Johnson Vision Care 發行，並對一切內容負全部責任。© Johnson & Johnson Vision Care 版權所有 2002 - 2024。此網站是為台灣地區所使用。客服專線：0800-068-346。安視優®ACUVUE®</p>",
}

export default footer
